import React from "react";
import { footer, footerTouch, nav, socialIcon } from "../data/Data";
import { Link } from "react-router-dom";
import emailjs from 'emailjs-com'
import { useState } from 'react'
import "../css/homepage-sections.css"


const initialState = {
  name: '',
  email: '',
  message: '',
}
export default function Footer() {
  const [{ name, email, message }, setState] = useState(initialState)

  const handleChange = (e) => {
    const { name, value } = e.target
    setState((prevState) => ({ ...prevState, [name]: value }))
  }

  function onContactClick(type){

    switch(type){
      
      case "call":
        document.location.href = "tel:+916264208349";
        break;

        case "email":
          document.location.href= "mailto:ntincensesticks@gmail.com"
        break

        case "address":
          window.open("https://maps.app.goo.gl/KbZvmANdAmZXx9E29",'_blank')
        break


    }

  }
  const clearState = () => setState({ ...initialState })

  const handleSubmit = (e) => {
    e.preventDefault()
    console.log(name, email, message)
    emailjs
      .sendForm(
        'service_cott3tr', 'template_449qdup', e.target, 'a2RAs1ZB10E12-kyC'
      )
      .then(
        (result) => {
          console.log(result.text)
          clearState()
          document.getElementById("sentMessage").reset();
        },
        (error) => {
          console.log(error.text)
        }
      )
  }

  return (
    <>
      <div className="professional-footer">
        {/* Newsletter Section */}
        {/* <div className="footer-newsletter-section">
          <div className="container-fluid py-5">
            <div className="row justify-content-center">
              <div className="col-lg-8 text-center">
                <div className="newsletter-content">
                  <div className="newsletter-icon">
                    <i className="fas fa-leaf"></i>
                  </div>
                  <h3 className="newsletter-title">Stay Connected with Sacred Fragrances</h3>
                  <p className="newsletter-subtitle">
                    Join our community and receive exclusive updates on new arrivals, spiritual insights, and special offers on premium incense products.
                  </p>
                  <form className="newsletter-form" name='sentMessage' id="sentMessage" onSubmit={handleSubmit}>
                    <div className="form-row">
                      <div className="col-md-4 mb-3">
                        <input
                          type='text'
                          id='name'
                          name='name'
                          className='form-control newsletter-input'
                          placeholder='Your Name'
                          required
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-md-5 mb-3">
                        <input
                          type='email'
                          id='email'
                          name='email'
                          className='form-control newsletter-input'
                          placeholder='Your Email Address'
                          required
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-md-3 mb-3">
                        <button type="submit" className="professional-newsletter-btn">
                          <i className="fas fa-paper-plane mr-2"></i>
                          Subscribe
                        </button>
                      </div>
                    </div>
                    <textarea
                      name='message'
                      id='message'
                      className='form-control newsletter-textarea mt-3'
                      rows='3'
                      placeholder='Share your thoughts or questions about our products...'
                      onChange={handleChange}
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        {/* Main Footer Content */}
        <div className="footer-main-content">
          <div className="container-fluid py-5">
            <div className="row px-xl-5">
              {/* Brand Section */}
              <div className="col-lg-4 col-md-6 mb-5">
                <div className="footer-brand-section">
                  <div className="footer-logo">
                    <span className="footer-logo-part-nt">NT</span>
                    <span className="footer-logo-part-sticks">STICKS</span>
                  </div>
                  <p className="brand-description">
                    Ntstick.com brings you the finest collection of natural fragrance products. Discover handpicked incense, prayer accessories, and lifestyle products that connect you with ancient traditions and modern wellness.
                  </p>
                  <div className="brand-highlights">
                    <div className="highlight-item">
                      <i className="fas fa-leaf"></i>
                      <span>100% Natural Ingredients</span>
                    </div>
                    <div className="highlight-item">
                      <i className="fas fa-hand-holding-heart"></i>
                      <span>Handcrafted with Love</span>
                    </div>
                    <div className="highlight-item">
                      <i className="fas fa-shipping-fast"></i>
                      <span>Fast & Secure Delivery</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Contact Information */}
              <div className="col-lg-4 col-md-6 mb-5">
                <div className="footer-contact-section">
                  <h5 className="footer-section-title">
                    <i className="fas fa-phone-alt mr-2"></i>
                    Get In Touch
                  </h5>
                  <div className="contact-items">
                    {footerTouch.map((val, index) => (
                      <div className="contact-item" key={index}>
                        <div className="contact-icon">
                          {val.icon}
                        </div>
                        <div className="contact-details">
                          <a onClick={()=>onContactClick(val.type)} className="contact-link">
                            {val.contact}
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                  
                  <div className="business-hours">
                    <h6 className="hours-title">
                      <i className="fas fa-clock mr-2"></i>
                      Business Hours
                    </h6>
                    <div className="hours-item">
                      <span>Monday - Saturday:</span>
                      <span>9:00 AM - 7:00 PM</span>
                    </div>
                    <div className="hours-item">
                      <span>Sunday:</span>
                      <span>10:00 AM - 5:00 PM</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Social & Legal */}
              <div className="col-lg-4 col-md-12 mb-5">
                <div className="footer-social-section">
                  <h5 className="footer-section-title">
                    <i className="fas fa-users mr-2"></i>
                    Connect With Us
                  </h5>
                  <p className="social-description">
                    Join our community of fragrance enthusiasts and spiritual seekers. Follow us for daily inspiration and product updates.
                  </p>
                  
                  <div className="social-links">
                    {socialIcon.map((icon, index) => (
                      <a
                        className="social-link"
                        href={icon.link}
                        key={index}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {icon.icon}
                      </a>
                    ))}
                  </div>

                  <div className="legal-links">
                    <h6 className="legal-title">
                      <i className="fas fa-shield-alt mr-2"></i>
                      Legal Information
                    </h6>
                    <div className="legal-items">
                      <Link to={"/privacy"} className="legal-link">Privacy Policy</Link>
                      <Link to={"/returnrefund"} className="legal-link">Return & Refund Policy</Link>
                      <Link to={"/shipping"} className="legal-link">Shipping Policy</Link>
                      <Link to={"/terms"} className="legal-link">Terms & Conditions</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="container-fluid py-4">
            <div className="row align-items-center px-xl-5">
              <div className="col-md-6">
                <p className="copyright-text">
                  &copy; {new Date().getFullYear()} All Rights Reserved by{" "}
                  <a
                    className="company-link"
                    href="https://www.instagram.com/nt_incense_sticks?igsh=dWpibWZsZ3ZpaXMz"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    ACHHARI PERFUMERY WORKS
                  </a>
                </p>
              </div>
              <div className="col-md-6 text-right">
                <div className="footer-badges">
                  <span className="quality-badge">
                    <i className="fas fa-certificate mr-1"></i>
                    Premium Quality
                  </span>
                  <span className="eco-badge">
                    <i className="fas fa-leaf mr-1"></i>
                    Eco-Friendly
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
